import React from "react";
import DownTime from "../../../components/DownTime/DownTime";
const DownTimePage = () => {
  return <DownTime />;
};

export default DownTimePage;
